import React from 'react';
import styled from "styled-components";

const Timer = ({ leftComponent, timeRemaining, rightComponent, background }) => (
    <TimerWrapper background={background}>
        <TimerComponentHolder>
            {
                timeRemaining?.isTime
                    ? 'Time up!'
                    : `${timeRemaining?.minute}:${timeRemaining?.second}`
            }

            <RightComponentHolder>
                {rightComponent ? rightComponent : ''}
            </RightComponentHolder>
        </TimerComponentHolder>
    </TimerWrapper>
);

export default Timer;

const TimerWrapper = styled.div`
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    padding: 23px 20px;
    background-color: ${(prop) => prop.background};
    font-family: MTNRegular;
    z-index: 2;
    text-align: center;
    font-size: 18px;
    color: #fff;
`;

const TimerComponentHolder = styled.div`
    position: relative;
    width: 100%;
    box-sizing: border-box;
`

const RightComponentHolder = styled.div`
    position: absolute;
    top: -3px;
    right: 0px;
`
